import { css } from "@obby/components";

export const styles = {
  accountForms: css({
    maxWidth: "500px",
    backgroundColor: "#fff"
  })
};
